// extracted by mini-css-extract-plugin
export default {"color":"TimeSelect_color__EN2dW","no-border-no-arrow":"TimeSelect_no-border-no-arrow__ZRSrX"};